export function getFullName(
  firstName?: string | null,
  lastName?: string | null,
) {
  return `${firstName || ""} ${lastName || ""}`.trim();
}

/**
 * Split a full name into first and last name.
 * First word becomes firstName, remaining words become lastName.
 */
export function splitName(name: string): {
  firstName: string;
  lastName: string;
} {
  const parts = name.split(" ");
  return { firstName: parts[0] ?? "", lastName: parts.slice(1).join(" ") };
}
